
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <h1 className="text-6xl font-bold text-primary">404</h1>
      <h2 className="mt-4 text-2xl font-semibold">Sayfa Bulunamadı</h2>
      <p className="mt-2 text-muted-foreground">
        Aradığınız sayfa bulunamadı veya artık mevcut değil.
      </p>
      <div className="mt-8 flex gap-4">
        <Button onClick={() => navigate(-1)}>Geri Dön</Button>
        <Button variant="outline" onClick={() => navigate("/dashboard")}>
          Dashboard
        </Button>
      </div>
    </div>
  );
}
